import { bannerDecorators, type BannerDecorator } from './bannerDecorators';

export interface DynamicBannerDecoratorProps {
  type?: BannerDecorator;
}

export const DynamicBannerDecorator = ({ type }: DynamicBannerDecoratorProps) => {
  const Decorator = type && bannerDecorators[type];

  if (!Decorator) {
    return null;
  }

  return <Decorator />;
};
